<template>
  <div id="video">
    <div :class="'youtube position-relative cursor-pointer video-' + videoId">
      <div class="play-button cursor-pointer" @click="loadYoutubeVideo(videoId)" tooltip="Video Starten"></div>
    </div>
    <div id="message">{{ $translate("KrauseSohn::Template.youtubeDataTransfer") }}</div>
  </div>
</template>
<script>
export default {
            props: [
              "videoId"
            ],

            methods: {
                loadYoutubeVideo(videoId)
                {
                    const youtube = document.querySelector(".video-" + videoId);
                    const iframe = document.createElement("iframe");

                    iframe.setAttribute("frameborder", "0");
                    iframe.setAttribute("allowfullscreen", "");
                    iframe.setAttribute("class", "w-100 h-100");
                    iframe.setAttribute("src", "https://www.youtube-nocookie.com/embed/" + videoId + "?rel=0&autoplay=1");
                    youtube.innerHTML = "";
                    youtube.appendChild(iframe);
                }
            }
        }
</script>
